import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    leadersList: {
        data: [],
        loading: false,
        error: null,
        page: 1,
        limit: 20,
        total: 0,
        totalPages: 0,
    },
    selectedLeaderId: null,
    leaderDetails: null,
    leaderDetailsLoading: false,
    leaderDetailsError: null,
};

const leaderSlice = createSlice({
    name: 'leader',
    initialState,
    reducers: {
        fetchLeadersStart: (state) => {
            state.leadersList.loading = true;
            state.leadersList.error = null;
        },
        fetchLeadersSuccess: (state, action) => {
            state.leadersList = {
                ...action.payload,
                loading: false,
                error: null,
            };
        },
        fetchLeadersFail: (state, action) => {
            state.leadersList.loading = false;
            state.leadersList.error = action.payload;
        },
        setSelectedLeaderId: (state, action) => {
            state.selectedLeaderId = action.payload;
        },
        fetchLeaderDetailsStart: (state) => {
            state.leaderDetailsLoading = true;
            state.leaderDetailsError = null;
        },
        fetchLeaderDetailsSuccess: (state, action) => {
            state.leaderDetailsLoading = false;
            state.leaderDetails = action.payload;
        },
        fetchLeaderDetailsFail: (state, action) => {
            state.leaderDetailsLoading = false;
            state.leaderDetailsError = action.payload;
            state.leaderDetails = null;
        },
    },
});

export const {
    fetchLeadersStart,
    fetchLeadersSuccess,
    fetchLeadersFail,
    setSelectedLeaderId,
    fetchLeaderDetailsStart,
    fetchLeaderDetailsSuccess,
    fetchLeaderDetailsFail,
} = leaderSlice.actions;

export default leaderSlice.reducer;
